// extracted by mini-css-extract-plugin
module.exports = {"black":"#000000","mobile":"500px","container":"SignUpFlow_container___Q1JQ","imageWrapper":"SignUpFlow_imageWrapper__rasu4"};